import React from "react";
import AllPageFooter from "../../../PreviewPdf/AllPageFooter";
import ReportImage from "../ReportImage";
import { isNullOrWhiteSpace } from "../../utils/reportHelpers";
import { resolveProxyImageUrl } from "../../utils/reportImageUrl";

const COMMUNAL_PAGE_SIZE = 4;

const CommunalDoorsPage = React.memo(function CommunalDoorsPage({
  reportData,
  imageProxyBaseUrl,
  pageNum,
  propLogo,
  communalPageIndex = 0,
}) {
  const doorList = reportData?.propertyInspectionReport?.doorSummaryDto ?? [];
  const start = communalPageIndex * COMMUNAL_PAGE_SIZE;
  const pageItems = doorList.slice(start, start + COMMUNAL_PAGE_SIZE);

  const resolveStaticFileurl = (str) => {
    if (isNullOrWhiteSpace(str)) return null;
    return str.trim();
  };

  return (
    <div className="page sheet">
      <div className="flat-doors">
        <div className="fd-header">
          <div className="fd-title">Flat Doors</div>
          <div className="fd-rule" />
        </div>
        {pageItems.map((door) => {
          const doorImageUrl = resolveProxyImageUrl(
            door?.doorImageBase64,
            imageProxyBaseUrl,
          );
          const staticUrl = resolveStaticFileurl(door.doorStaticImage);
          let locationText;
          if (
            !isNullOrWhiteSpace(door?.floorNo) &&
            !isNullOrWhiteSpace(door?.doorLocation)
          ) {
            locationText = `Floor-${door.floorNo}-${door.doorLocation}`;
          } else {
            locationText = !isNullOrWhiteSpace(door?.floorNo)
              ? `Floor-${door.floorNo}`
              : door?.doorLocation ?? "";
          }

          return (
            <table
              key={door.doorId ?? door.inspectedDoorId ?? door.doorRefNumber}
              className="fd-card"
            >
              <tbody>
                <tr>
                  <td className="fd-left">
                    <div className="fd-photo">
                      {doorImageUrl ? (
                        <ReportImage src={doorImageUrl} alt="Door photo" />
                      ) : (
                        <ReportImage src={staticUrl} alt="Door image" />
                      )}
                    </div>
                  </td>
                  <td className="fd-mid">
                    <table className="fd-mid-table">
                      <tbody>
                        <tr>
                          <td className="fd-mid-a">
                            <div className="fd-label">Door Ref Number</div>
                            <span className="fd-value">
                              {door?.doorRefNumber ?? ""}
                            </span>
                            <div className="fd-label">Location</div>
                            <div className="fd-location">{locationText}</div>
                          </td>
                          <td className="fd-mid-b">
                            <div className="fd-label">Fire Rating</div>
                            <span className="fd-value">
                              {door?.fireRating ?? ""}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td className="fd-right">
                    <div className="fd-actions-num">
                      <a
                        href="https://fireinspect.com/client/propertyshield/actionRemediation"
                        className="fd-actions-link"
                      >
                        {door?.totalActionItems}
                      </a>
                    </div>
                    <div className="fd-actions-text">Actions Required</div>
                  </td>
                </tr>
              </tbody>
            </table>
          );
        })}
      </div>
      <AllPageFooter pageNumber={pageNum} propLogo={propLogo} />
    </div>
  );
});

export default CommunalDoorsPage;
